import React from "react";
import { CreditCard, Pencil, Trash2, Wallet } from "lucide-react";

const upiApps = ["Google Pay", "Phone Pe", "Paytm", "Bhim"];

export default function PaymentMode() {
  return (
    <div className="bg-white rounded-2xl border border-gray-200 h-[calc(100vh-120px)] flex flex-col overflow-hidden">
      {/* Fixed Header */}
      <div className="shrink-0 border-b border-gray-100 bg-white px-6 py-5">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <h2 className="text-2xl sm:text-[28px] font-semibold text-gray-800">
            Payment Mode
          </h2>

          <button className="w-full sm:w-auto px-5 h-11 rounded-full border border-gray-300 hover:bg-gray-50 text-gray-700">
            Add New Card
          </button>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto hide-scrollbar px-6 py-6">
        {/* Saved Card */}
        <div className="mb-7">
          <h3 className="text-sm font-medium text-gray-700 mb-4">Saved Card</h3>

          <div className="w-full sm:max-w-[420px] border rounded-2xl p-5">
            <div className="flex justify-between">
              <CreditCard className="text-orange-500" size={22} />

              <span className="px-2 py-1 rounded bg-orange-100 text-orange-500 text-xs font-medium">
                Default
              </span>
            </div>

            <h4 className="font-semibold text-gray-700 mt-3">
              HDFC Debit Card
            </h4>

            <p className="text-sm text-gray-400 mt-1">**** **** **** 4521</p>

            <div className="text-right text-xs text-gray-400 mt-2">
              Expires 08/28
            </div>

            <div className="border-t mt-4 pt-4 flex flex-wrap gap-4">
              <button className="flex items-center gap-2 text-sm text-gray-600 hover:text-black">
                <Pencil size={15} />
                Edit
              </button>

              <button className="flex items-center gap-2 text-sm text-gray-600 hover:text-red-500">
                <Trash2 size={15} />
                Delete
              </button>
            </div>
          </div>
        </div>

        {/* UPI */}
        <div className="mb-7">
          <h3 className="text-sm font-medium text-gray-700 mb-4">UPI</h3>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
            {upiApps.map((app) => (
              <div
                key={app}
                className="h-24 border rounded-2xl flex flex-col items-center justify-center hover:shadow-sm cursor-pointer"
              >
                <div className="w-10 h-10 bg-gray-200 rounded mb-3"></div>

                <span className="text-sm text-gray-600 text-center">{app}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Wallet */}
        <div>
          <h3 className="text-sm font-medium text-gray-700 mb-4">Wallet</h3>

          <div className="w-full sm:max-w-[420px] border rounded-2xl p-5">
            <div className="flex items-center justify-between">
              <div>
                <h4 className="font-semibold text-gray-700">Chaafo Wallet</h4>

                <p className="text-sm text-gray-400 mt-1">Balance: ₹1,243</p>
              </div>

              <Wallet className="text-orange-500" size={22} />
            </div>

            <div className="border-t mt-4 pt-4 flex flex-col sm:flex-row gap-3">
              <button className="w-full sm:w-auto px-4 py-2 rounded-full border text-sm hover:bg-gray-50">
                Add Money
              </button>

              <button className="w-full sm:w-auto px-4 py-2 rounded-full border text-sm hover:bg-gray-50">
                Top Up
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
